import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js-stable/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js-stable/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
function ownKeys(e, r) {
  var t = _Object$keys(e);
  if (_Object$getOwnPropertySymbols) {
    var o = _Object$getOwnPropertySymbols(e);
    r && (o = _filterInstanceProperty(o).call(o, function (r) {
      return _Object$getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
import React, { useCallback } from "react";
import PropTypes from "prop-types";
import { ErrorBoundary, Loader, ModalNextEmitter } from "@jutro/components";
import { getConfigValue } from "@jutro/config";
import { warning } from "@jutro/logger";
import { useDeepMemo } from "@jutro/platform";
import { deprecated } from "@jutro/prop-types";
import { AuthenticatedGlobalizedContent, GlobalizedContent } from "./internationalization/GlobalizedContent";
import { MessagesContextProvider } from "./internationalization/MessagesContext";
import { AuthErrorPage } from "./routing/AuthErrorPage";
import { RootRoute } from "./routing/RootRoute";
import { RoutingContent } from "./routing/RoutingContent";
import { ApplicationContent } from "./ApplicationContent";
import { applyHOCs } from "./ApplicationRootHOCs";
export var ApplicationRoot = function (props) {
  var _defaultProps$props = _objectSpread(_objectSpread({}, defaultProps), props),
    authErrorComponent = _defaultProps$props.authErrorComponent,
    messageLoader = _defaultProps$props.messageLoader,
    coreMessageLoader = _defaultProps$props.coreMessageLoader,
    appName = _defaultProps$props.appName,
    intlTextComponent = _defaultProps$props.intlTextComponent,
    disableAuthForApplicationRoot = _defaultProps$props.disableAuthForApplicationRoot,
    globalizationSettings = _defaultProps$props.globalizationSettings,
    saveDefaultLanguageAndLocaleToLocalStorage = _defaultProps$props.saveDefaultLanguageAndLocaleToLocalStorage,
    refreshOnLanguageOrLocaleChange = _defaultProps$props.refreshOnLanguageOrLocaleChange,
    routerComponent = _defaultProps$props.Router,
    routerHistory = _defaultProps$props.routerHistory,
    routerBasename = _defaultProps$props.routerBasename,
    trackingCallback = _defaultProps$props.trackingCallback,
    modalEmitter = _defaultProps$props.modalEmitter,
    ErrorBoundaryComponent = _defaultProps$props.errorBoundary,
    authComponent = _defaultProps$props.authComponent,
    rootHOCs = _defaultProps$props.rootHOCs,
    useG11nStore = _defaultProps$props.useG11nStore,
    g11nStore = _defaultProps$props.g11nStore,
    mainComponent = _defaultProps$props.main,
    mainComponentProps = _defaultProps$props.mainComponentProps,
    disableModalProvider = _defaultProps$props.disableModalProvider,
    modalFunctions = _defaultProps$props.modalFunctions,
    disableToastProvider = _defaultProps$props.disableToastProvider,
    toastTrigger = _defaultProps$props.toastTrigger,
    loaderComponent = _defaultProps$props.loaderComponent,
    hideSkipNavigation = _defaultProps$props.hideSkipNavigation,
    authEnabled = Boolean(getConfigValue("JUTRO_AUTH_ENABLED", !1) && !disableAuthForApplicationRoot),
    mainComponentPropsMemoized = useDeepMemo(function () {
      return mainComponentProps;
    }, [null == mainComponentProps ? void 0 : mainComponentProps.propsFromShell]),
    renderBody = useCallback(function (_ref) {
      var _ref$isAuthenticated = _ref.isAuthenticated,
        isAuthenticated = void 0 === _ref$isAuthenticated || _ref$isAuthenticated;
      return React.createElement(React.Fragment, null, isAuthenticated && React.createElement(AuthenticatedGlobalizedContent, null), React.createElement(ApplicationContent, {
        mainComponent: mainComponent,
        mainComponentProps: mainComponentPropsMemoized,
        disableToastProvider: disableToastProvider,
        toastTrigger: toastTrigger,
        disableModalProvider: disableModalProvider,
        modalEmitter: modalEmitter,
        modalFunctions: modalFunctions,
        loaderComponent: loaderComponent,
        isAuthenticated: isAuthenticated,
        hideSkipNavigation: hideSkipNavigation,
        appName: appName
      }));
    }, [appName, disableModalProvider, disableToastProvider, hideSkipNavigation, loaderComponent, mainComponent, mainComponentPropsMemoized, modalEmitter, modalFunctions, toastTrigger]);
  return React.createElement(ErrorBoundaryComponent, {
    noticeStyle: "fullHeight"
  }, applyHOCs(React.createElement(RoutingContent, {
    routerComponent: routerComponent,
    routerBasename: routerBasename,
    routerHistory: routerHistory,
    trackingCallback: trackingCallback,
    modalEmitter: modalEmitter
  }, React.createElement(MessagesContextProvider, null, React.createElement(GlobalizedContent, {
    globalizationSettings: globalizationSettings,
    appName: appName,
    messageLoader: messageLoader,
    coreMessageLoader: coreMessageLoader,
    intlTextComponent: intlTextComponent,
    useG11nStore: useG11nStore,
    store: g11nStore,
    persistToURL: refreshOnLanguageOrLocaleChange,
    persistToLocalStorage: saveDefaultLanguageAndLocaleToLocalStorage
  }, React.createElement(RootRoute, {
    path: "/",
    render: renderBody,
    authEnabled: authEnabled,
    authErrorComponent: authErrorComponent,
    authComponent: authComponent
  })))), rootHOCs));
};
ApplicationRoot.propTypes = {
  messageLoader: PropTypes.func,
  coreMessageLoader: PropTypes.func,
  intlTextComponent: PropTypes.string,
  errorBoundary: PropTypes.elementType,
  loaderComponent: PropTypes.elementType,
  authComponent: PropTypes.elementType,
  main: PropTypes.func.isRequired,
  mainComponentProps: PropTypes.object,
  trackingCallback: PropTypes.func,
  Router: PropTypes.elementType,
  routerHistory: PropTypes.object,
  routerBasename: PropTypes.string,
  rootHOCs: PropTypes.oneOfType([PropTypes.func, PropTypes.arrayOf(PropTypes.func)]),
  useG11nStore: PropTypes.bool,
  authErrorComponent: PropTypes.func,
  modalEmitter: PropTypes.instanceOf(ModalNextEmitter),
  refreshOnLanguageOrLocaleChange: deprecated(PropTypes.bool, "10.0.0", "Use g11nStore instead."),
  saveDefaultLanguageAndLocaleToLocalStorage: deprecated(PropTypes.bool, "10.0.0", "Use g11nStore instead."),
  globalizationSettings: deprecated(PropTypes.shape({
    getAvailableLanguages: PropTypes.func.isRequired,
    getAvailableLocales: PropTypes.func.isRequired,
    getDefaultCountryCode: PropTypes.func.isRequired,
    getDefaultCurrency: PropTypes.func.isRequired,
    getDefaultTimeZone: PropTypes.func.isRequired,
    getPreferredLanguage: PropTypes.func.isRequired,
    getPreferredLocale: PropTypes.func.isRequired,
    onGlobalizationChange: PropTypes.func
  }), "10.0.0", "Use config localeSettings or g11nStore instead.")
};
var defaultProps = {
  messageLoader: function (locale) {
    return warning("No application specific message resources loaded for locale: ".concat(locale)), {};
  },
  coreMessageLoader: function (locale) {
    return warning("No core message resources loaded for locale: ".concat(locale)), {};
  },
  errorBoundary: ErrorBoundary,
  loaderComponent: Loader,
  routerBasename: getConfigValue("JUTRO_ROUTER_BASENAME", ""),
  authErrorComponent: AuthErrorPage,
  modalEmitter: new ModalNextEmitter()
};
ApplicationRoot.__docgenInfo = {
  description: "A root-level component that takes care of application-level\nconcerns for you:\n-- internationalization\n-- routing\n-- error handling (uncaught)\nIf the application requires a custom HOC, rootHOCs render prop\ncan be used, e.g. <ApplicationRoot rootHOCs={composeRedux(store)} />.\nArray of HOCs are applied in order starting with first to last and then\nErrorBoundary is added.\n\n@param messages",
  methods: [],
  displayName: "ApplicationRoot",
  props: {
    messageLoader: {
      type: {
        name: "func"
      },
      required: !1,
      description: "The function to load locale messages"
    },
    coreMessageLoader: {
      type: {
        name: "func"
      },
      required: !1,
      description: "The function to load core app locale messages"
    },
    intlTextComponent: {
      type: {
        name: "string"
      },
      required: !1,
      description: "The tag to render text inside of react-intl <Formatted*> components; defaults to React.Fragment (https://formatjs.io/docs/react-intl/upgrade-guide-3x)"
    },
    errorBoundary: {
      type: {
        name: "elementType"
      },
      required: !1,
      description: "The application 'catch-all' error boundary"
    },
    loaderComponent: {
      type: {
        name: "elementType"
      },
      required: !1,
      description: "The component for wrapping the main component and presenting a loader UI when the app is loading"
    },
    authComponent: {
      type: {
        name: "elementType"
      },
      required: !1,
      description: "The authentication provider. It has access to router and globalization context"
    },
    main: {
      type: {
        name: "func"
      },
      required: !0,
      description: "The application entry component"
    },
    mainComponentProps: {
      type: {
        name: "object"
      },
      required: !1,
      description: "Any props to be passed to the main component"
    },
    trackingCallback: {
      type: {
        name: "func"
      },
      required: !1,
      description: "callback fired by RouteTracker on route change with values location, action"
    },
    Router: {
      type: {
        name: "elementType"
      },
      required: !1,
      description: "The router to use"
    },
    routerHistory: {
      type: {
        name: "object"
      },
      required: !1,
      description: "configuration for creating  MemoryHistory or BrowserHistory"
    },
    routerBasename: {
      type: {
        name: "string"
      },
      required: !1,
      description: "The base URL for all locations. If you serve the app from a sub-directory on your server,\nyou'll want to set this to the sub-directory. A properly formatted basename should have a leading slash,\nbut no trailing slash."
    },
    rootHOCs: {
      type: {
        name: "union",
        value: [{
          name: "func"
        }, {
          name: "arrayOf",
          value: {
            name: "func"
          }
        }]
      },
      required: !1,
      description: "HOC which provides store, e.g. Redux composing function"
    },
    useG11nStore: {
      type: {
        name: "bool"
      },
      required: !1,
      description: ""
    },
    authErrorComponent: {
      type: {
        name: "func"
      },
      required: !1,
      description: "a custom error component to render on the auth redirect path"
    },
    modalEmitter: {
      type: {
        name: "instanceOf",
        value: "ModalNextEmitter"
      },
      required: !1,
      description: "Instance of ModalNextEmitter passed down to ModalNextProvider for triggering modal functions from outside the scope of the ModalNextProvider"
    },
    refreshOnLanguageOrLocaleChange: {
      type: {
        name: "custom",
        raw: "deprecated(\n    PropTypes.bool,\n    '10.0.0',\n    'Use g11nStore instead.'\n)"
      },
      required: !1,
      description: "if `true`, reloads on every language or locale change (`window.location.reload()`).\n@default false"
    },
    saveDefaultLanguageAndLocaleToLocalStorage: {
      type: {
        name: "custom",
        raw: "deprecated(\n    PropTypes.bool,\n    '10.0.0',\n    'Use g11nStore instead.'\n)"
      },
      required: !1,
      description: "if `true`, saves default language and locale to localStorage if not already set.\n@default true"
    },
    globalizationSettings: {
      type: {
        name: "custom",
        raw: "deprecated(\n    PropTypes.shape({\n        getAvailableLanguages: PropTypes.func.isRequired,\n        getAvailableLocales: PropTypes.func.isRequired,\n        getDefaultCountryCode: PropTypes.func.isRequired,\n        getDefaultCurrency: PropTypes.func.isRequired,\n        getDefaultTimeZone: PropTypes.func.isRequired,\n        getPreferredLanguage: PropTypes.func.isRequired,\n        getPreferredLocale: PropTypes.func.isRequired,\n        onGlobalizationChange: PropTypes.func,\n    }),\n    '10.0.0',\n    'Use config localeSettings or g11nStore instead.'\n)"
      },
      required: !1,
      description: "An optional source of globalization configs to seed GlobalizationProvider, defaults to a LocaleService-based implementation.\nPlease see the precise type GlobalizationSettings for more details."
    }
  }
}, ApplicationRoot.__docgenInfo = {
  componentName: "ApplicationRoot",
  packageName: "@jutro/app",
  description: "A root-level component that takes care of application-level\nconcerns for you:\n-- internationalization\n-- routing\n-- error handling (uncaught)\nIf the application requires a custom HOC, rootHOCs render prop\ncan be used, e.g. <ApplicationRoot rootHOCs={composeRedux(store)} />.\nArray of HOCs are applied in order starting with first to last and then\nErrorBoundary is added.",
  displayName: "ApplicationRoot",
  methods: [],
  actualName: "ApplicationRoot",
  props: {
    messageLoader: {
      type: {
        name: "func"
      },
      required: !1,
      description: "The function to load locale messages"
    },
    coreMessageLoader: {
      type: {
        name: "func"
      },
      required: !1,
      description: "The function to load core app locale messages"
    },
    intlTextComponent: {
      type: {
        name: "string"
      },
      required: !1,
      description: "The tag to render text inside of react-intl <Formatted*> components; defaults to React.Fragment (https://formatjs.io/docs/react-intl/upgrade-guide-3x)"
    },
    errorBoundary: {
      type: {
        name: "elementType"
      },
      required: !1,
      description: "The application 'catch-all' error boundary"
    },
    loaderComponent: {
      type: {
        name: "elementType"
      },
      required: !1,
      description: "The component for wrapping the main component and presenting a loader UI when the app is loading"
    },
    authComponent: {
      type: {
        name: "elementType"
      },
      required: !1,
      description: "The authentication provider. It has access to router and globalization context"
    },
    main: {
      type: {
        name: "func"
      },
      required: !0,
      description: "The application entry component"
    },
    mainComponentProps: {
      type: {
        name: "object"
      },
      required: !1,
      description: "Any props to be passed to the main component"
    },
    trackingCallback: {
      type: {
        name: "func"
      },
      required: !1,
      description: "callback fired by RouteTracker on route change with values location, action"
    },
    Router: {
      type: {
        name: "elementType"
      },
      required: !1,
      description: "The router to use"
    },
    routerHistory: {
      type: {
        name: "object"
      },
      required: !1,
      description: "configuration for creating  MemoryHistory or BrowserHistory"
    },
    routerBasename: {
      type: {
        name: "string"
      },
      required: !1,
      description: "The base URL for all locations. If you serve the app from a sub-directory on your server,\nyou'll want to set this to the sub-directory. A properly formatted basename should have a leading slash,\nbut no trailing slash."
    },
    rootHOCs: {
      type: {
        name: "union",
        value: [{
          name: "func"
        }, {
          name: "arrayOf",
          value: {
            name: "func"
          }
        }]
      },
      required: !1,
      description: "HOC which provides store, e.g. Redux composing function"
    },
    useG11nStore: {
      type: {
        name: "bool"
      },
      required: !1,
      description: ""
    },
    authErrorComponent: {
      type: {
        name: "func"
      },
      required: !1,
      description: "a custom error component to render on the auth redirect path"
    },
    modalEmitter: {
      type: {
        name: "instanceOf",
        value: "ModalNextEmitter"
      },
      required: !1,
      description: "Instance of ModalNextEmitter passed down to ModalNextProvider for triggering modal functions from outside the scope of the ModalNextProvider"
    },
    refreshOnLanguageOrLocaleChange: {
      type: {
        name: "bool"
      },
      required: !1,
      description: "@deprecated if `true`, reloads on every language or locale change (`window.location.reload()`).\n@default false",
      deprecationInfo: {
        version: "10.0.0",
        mapTo: null
      }
    },
    saveDefaultLanguageAndLocaleToLocalStorage: {
      type: {
        name: "bool"
      },
      required: !1,
      description: "@deprecated if `true`, saves default language and locale to localStorage if not already set.\n@default true",
      deprecationInfo: {
        version: "10.0.0",
        mapTo: null
      }
    },
    globalizationSettings: {
      type: {
        name: "shape",
        value: {
          getAvailableLanguages: {
            name: "func",
            required: !0
          },
          getAvailableLocales: {
            name: "func",
            required: !0
          },
          getDefaultCountryCode: {
            name: "func",
            required: !0
          },
          getDefaultCurrency: {
            name: "func",
            required: !0
          },
          getDefaultTimeZone: {
            name: "func",
            required: !0
          },
          getPreferredLanguage: {
            name: "func",
            required: !0
          },
          getPreferredLocale: {
            name: "func",
            required: !0
          },
          onGlobalizationChange: {
            name: "func",
            required: !1
          }
        }
      },
      required: !1,
      description: "@deprecated An optional source of globalization configs to seed GlobalizationProvider, defaults to a LocaleService-based implementation.\nPlease see the precise type GlobalizationSettings for more details.",
      deprecationInfo: {
        version: "10.0.0",
        mapTo: null
      }
    }
  }
};